import React from "react";
import classNames from "classnames";

import withTranslations from "../../../../../hocs/withTranslations";
import SettingsIcon from "../../../landingPage/pages/Homepage/assets/icons/settings.svg";
import showStrategyNotificationSettingsModal from "../utils/showStrategyNotificationSettingsModal";

const StrategyLatestNotificationsSettingsButton = ({
  translate,
  enabledNotificationTypesCount,
  notificationTypes
}) => (
  <button
    type="button"
    className={
      "relative flex align-center justify-center shrink-0 border-none rounded-1 w-8 h-8 bg-gray-5 text-black-5 hover:text-black hover:opacity-65"
    }
    aria-label={translate(
      "sid_dashboard_notification_settings_button_aria_label"
    )}
    onClick={() => {
      showStrategyNotificationSettingsModal({ translate, notificationTypes });
    }}
  >
    <img src={SettingsIcon} alt="" width={16} height={16} aria-hidden="true" />
    <span
      className={
        "absolute flex align-center justify-center min-w-3.5 h-3.5 px-0.5 rounded-full bg-yellow text-black font-bold text-xs.2"
      }
      style={{ top: 2, right: 2 }}
      aria-hidden="true"
    >
      {enabledNotificationTypesCount}
    </span>
  </button>
);

export default withTranslations(StrategyLatestNotificationsSettingsButton);
